export default __webpack_public_path__ + "static/media/no-debates.3a4abdc0.png";